/**
 * Zwraca ikonę i grupę kolorystyczną dla danego typu powiadomienia
 * @param {string} type - Typ powiadomienia
 * @returns {{ icon: string, group: string }} Dane ikony
 */
export function getNotificationIcon(type) {
  const iconMap = {
    application_received: { icon: 'application-received', group: 'application' },
    application_accepted: { icon: 'accepted', group: 'success' },
    application_rejected: { icon: 'rejected', group: 'alert' },
    event_created: { icon: 'calendar-plus', group: 'event' },
    event_starts_soon: { icon: 'clock', group: 'event' },
    event_started: { icon: 'rocket', group: 'event' },
    event_cancelled: { icon: 'warning', group: 'alert' },
    participant_kicked: { icon: 'ban', group: 'alert' },
    event_invitation: { icon: 'invitation', group: 'event' },
    friend_invitation: { icon: 'handshake', group: 'friend' },
    friendship_accepted: { icon: 'accepted', group: 'friend' },
    friend_joined_event: { icon: 'users', group: 'friend' },
    badge_unlocked: { icon: 'trophy', group: 'badge' },
  };

  return iconMap[type] || { icon: 'bell', group: 'system' };
}
